import { sendGAEvent, sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';
import { isMiddleMouseClick } from '@noths/polaris-client-utils';
export var useTrackableLink = function useTrackableLink() {
  var trackLinkClick = function trackLinkClick(eventOrFn) {
    return function (evt) {
      var trackingEvent = typeof eventOrFn === 'function' ? eventOrFn(evt) : eventOrFn;
      sendGALinkClickEvent(evt, trackingEvent);
    };
  };
  var trackLinkMouseDown = function trackLinkMouseDown(eventOrFn) {
    return function (evt) {
      if (isMiddleMouseClick(evt)) {
        var trackingEvent = typeof eventOrFn === 'function' ? eventOrFn(evt) : eventOrFn;
        sendGAEvent(trackingEvent);
      }
    };
  };
  return {
    trackLinkClick,
    trackLinkMouseDown
  };
};